export class LinkType {
  active: boolean;
  id: number;
  description: string;
  iconHref: string;
  externalSourceType: string;
  isDefault: boolean;
  companyIdentifierTypeId: number;

  constructor (link: any = {}) {
    this.active = link.active || false;
    this.id = link.id || null;
    this.description = link.description || null;
    this.iconHref = link.iconHref || null;
    this.externalSourceType = link.externalSourceType || null;
    this.isDefault = link.isDefault || false;
    this.companyIdentifierTypeId = link.companyIdentifierTypeId || null;
  }
}
